/**
 * Field types that can be used in the Form Schema
 * @see FormJSONObject
 */
export const IkeFieldType = {
	DATE: 'date' as const,
	FORM: 'form' as const,
	LOCATION: 'location' as const,
	NESTED_LIST: 'nestedlist' as const,
	NUMBER: 'number' as const,
	ORIENTATION: 'orientation' as const,
	SELECT_LIST: 'selectlist' as const,
	TEXT: 'text' as const,
	HEIGHT: 'height' as const,
	TRUE_SIZE: 'truesizecapture' as const,
	YES_NO: 'yesno' as const,
	/**
	 * Generic image with no sensor data
	 * @see IkeCaptureType.IMAGE
	 */
	IMAGE: 'image' as const,
	VECTOR: 'vector' as const,
	VERTICAL_SEPARATION: 'verticalseparation' as const,
	FILE_TOOL: 'filetool' as const,
	ANCHOR: 'anchor' as const,
	LINE: 'line' as const,
	ASSET_TYPE: 'assettype' as const,
};
export type IkeFieldType =
	| typeof IkeFieldType.DATE
	| typeof IkeFieldType.FORM
	| typeof IkeFieldType.LOCATION
	| typeof IkeFieldType.NESTED_LIST
	| typeof IkeFieldType.NUMBER
	| typeof IkeFieldType.ORIENTATION
	| typeof IkeFieldType.SELECT_LIST
	| typeof IkeFieldType.TEXT
	| typeof IkeFieldType.HEIGHT
	| typeof IkeFieldType.TRUE_SIZE
	| typeof IkeFieldType.YES_NO
	| typeof IkeFieldType.IMAGE
	| typeof IkeFieldType.VECTOR
	| typeof IkeFieldType.VERTICAL_SEPARATION
	| typeof IkeFieldType.FILE_TOOL
	| typeof IkeFieldType.ANCHOR
	| typeof IkeFieldType.LINE
	| typeof IkeFieldType.ASSET_TYPE;
